<template>
  <b-row>
    <b-col cols="12">
      <TableComponents
        v-if="!showForm"
        :columns="columns"
        :rows="listAddressType"
        :title-table="$t('Address Type')"
        module="addressTypeSettingsModule"
        sort-name="nome"
        :add-permission="'ROLE_TIPO_ENDERECO_INSERIR'"
        :view-permission="'ROLE_TIPO_ENDERECO_CONSULTAR'"
        :edit-permission="'ROLE_TIPO_ENDERECO_ATUALIZAR'"
        :delete-permission="'ROLE_TIPO_ENDERECO_DELETAR'"
        @add="addNew"
        @edit="edit"
      />
      <FormAddressType
        v-else
        @cancelar="cancelar"
      />
    </b-col>
  </b-row>
</template>
<script>
import { mapState } from 'vuex'
import TableComponents from '@/layouts/components/TableComponents.vue'
import { BRow, BCol } from 'bootstrap-vue'
import FormAddressType from './forms/FormAddressType.vue'

export default {
  components: {
    BRow,
    BCol,
    TableComponents,
    FormAddressType,
  },
  computed: {
    ...mapState('addressTypeSettingsModule', {
      listAddressType: state => state.listAddressType,
    }),
  },
  data() {
    return {
      showForm: false,
      columns: [
        {
          label: 'Id',
          field: 'id',
        },
        {
          label: 'Descrição',
          field: 'nome',
        },
        {
          label: 'Ativo',
          field: 'ativo',
        },
        {
          label: 'Action',
          field: 'action',
        },
      ],
    }
  },
  methods: {
    addNew() {
      this.showForm = true
    },
    edit(data) {
      this.$store.dispatch(
        'addressTypeSettingsModule/prepareToEditAddressType',
        data,
      )
      this.showForm = true
    },
    cancelar() {
      this.showForm = false
    },
  },
}
</script>
